import { axios } from '@/utils/request'

// 获取商品列表
export function gettMallGoodsSkus(params) {
  return axios({
    url: `/mall/goods/skus`,
    method: 'get',
    params
  })
}

//保存商品信息
export function saveMallGoods(body){
  return axios({
    url: `/mall/goods`,
    method: 'post',
    data: body
  })
}

//根据id获取商品信息
export function getMallGoodsById(id){
  return axios({
    url: `/mall/goods/${id}`,
    method: 'get'
  })
}

//管理sku库存
export function updateMallGoodsSkuStock(body){
  return axios({
    url: `/mall/goods/sku/stock`,
    method: 'post',
    data: body
  })
}

//删除sku
export function deleteMallGoodsSku(id){
  return axios({
    url: `/mall/goods/sku/${id}`,
    method: 'delete'
  })
}

//sku操作记录
export function gettMallGoodsSkuRecord(params,id) {
  return axios({
    url: `/mall/goods/sku/${id}/record`,
    method: 'get',
    params
  })
}

//获取订单列表
export function gettMallOrder(params) {
  return axios({
    url: `/mall/orders`,
    method: 'get',
    params
  })
}

//订单状态置为处理中
export function updateMallOrderStatus(id){
  return axios({
    url: `/mall/order/${id}/processing`,
    method: 'post'
  })
}

//批量订单状态置为处理中
export function batchUpdateMallOrderStatus(body){
  return axios({
    url: `/mall/orders/processing`,
    method: 'post',
    data: body
  })
}

//取消订单
export function cancelMallOrder(id){
  return axios({
    url: `/mall/order/${id}/cancel`,
    method: 'post'
  })
}

//订单发货
export function deliverMallOrder(body){
  return axios({
    url: `/mall/order/delivery`,
    method: 'post',
    data: body
  })
}
